import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { userRole } from "./constant/userConfig";
import useAuthStore from "./store/authStore";

const ProtectedLayout = ({ allowedRoles }) => {
  const user = useAuthStore((state) => state.user);
  const logout = useAuthStore((state) => state.logout);
  // const token = useAuthStore((state) => state.token);
  const expiresAt = useAuthStore((state) => state.expiresAt);
  const navigate = useNavigate();
  //console.log("user", token);
  // 🛑 Si l'utilisateur n'est pas encore défini, rediriger vers la page de login
  if (!user || (expiresAt && new Date(expiresAt) < new Date())) {
    logout();
    return <Navigate to="/login" />;
  }
  //console.log("user", user);
  // 🚫 Si l'utilisateur n'a pas les permissions, le rediriger vers sa page

  const HandleNAvigation = (role) => {
    if (
      [
        userRole.admin_assurance,
        userRole.agent_assurance,
        userRole.medecin_assurance,
      ].includes(role)
    ) {
      navigate("/assurance");
    }
    /*
  if (!allowedRoles.includes(user.role)) {
    switch (user.role) {
      case "admin_assurance":
      case "agent_assurance":
      case "medecin_assurance":
        return <Navigate to="/assurance" />;
      case "admin_pharmacie":
      case "agent_pharmacie":
        return <Navigate to="/pharmacie" />;
      case "admin_laboratoire":
      case "agent_laboratoire":
        return <Navigate to="/labo" />;
      case "admin_clinique":
      case "agent_clinique":
      case "medecin_clinique":
        return <Navigate to="/clinique" />;
      default:
        return <Navigate to="/" />;

    }*/

    if (
      [
        userRole.admin_clinique,
        userRole.agent_clinique,
        userRole.medecin_clinique,
      ].includes(role)
    ) {
      /**logique pour la clinique */
      navigate("/clinique");
    }

    if ([userRole.admin_pharmacie, userRole.agent_pharmacie].includes(role)) {
      navigate("/pharmacie");
    }
    if (
      [userRole.admin_laboratoire, userRole.agent_laboratoire].includes(role)
    ) {
      navigate("/labo");
    }
    if (
      [
        userRole.admin_clinique_laboratoire,
        userRole.agent_clinique_laboratoire,
        userRole.medecin_clinique_laboratoire,
      ].includes(role)
    ) {
      navigate("/clinique-labo");
    }
  };

  if (allowedRoles.includes(user.role)) {
    // HandleNAvigation(user.role);
  } else {
    return <Navigate to="/" />;
  }

  return (
    <>
      <Outlet /> {/* Les routes enfants seront rendues ici */}
    </>
  );
};

export default ProtectedLayout;
